"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRealtimeClock = getRealtimeClock;
const duration_1 = require("@moojo/duration");
function getRealtimeClock() {
    return new RealtimeClock();
}
class RealtimeClock {
    now() {
        return (0, duration_1.instantOf)(Date.now());
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xvY2suanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2xvY2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFNQSw0Q0FFQztBQVJELDhDQUFvRDtBQU1wRCxTQUFnQixnQkFBZ0I7SUFDOUIsT0FBTyxJQUFJLGFBQWEsRUFBRSxDQUFBO0FBQzVCLENBQUM7QUFFRCxNQUFNLGFBQWE7SUFDakIsR0FBRztRQUNELE9BQU8sSUFBQSxvQkFBUyxFQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQyxDQUFBO0lBQzlCLENBQUM7Q0FDRiJ9